// 通用工具函数
let windowsMap = new Map()

const answerSheetWindowManager = {
    // 打开或聚焦AnswerSheet窗口
    openOrFocus: (routeHref, windowName) => {
        // debugger
        // // 尝试获取已存在的窗口引用
        // let existingWin = windowsMap.get('AnswerSheet')

        // if (existingWin && !existingWin.closed) {
        //     // 窗口已存在，更新URL并聚焦
        //     existingWin.location.href = routeHref
        //     existingWin.focus()
        //     //return existingWin
        // } else {
        //     // 窗口不存在，打开新窗口
        //     let newWin = window.open(routeHref, '_blank')
        //     // api.getData().then(res => {
        //     //     // 再更新窗口内容
        //     //     newWin.location.href = routeHref
        //     // })
        //     //return newWin
        //     windowsMap.set('AnswerSheet', newWin)
        // }

        debugger
        // const windowName = 'AnswerSheet';
        // // 获取或创建同名窗口


        let newWindow = window.open(routeHref, windowName);
        newWindow.location.reload();
        // debugger
        // // 关键：如果找到的窗口是当前窗口，需要特殊处理
        // if (window && !window.closed) {
        //     // 如果存在窗口且不是当前窗口（真正的其他窗口）
        //     if (existingWindow != window) {
        //         //     // 关闭旧的窗口
        //         //    // existingWindow.close();
        //         //     // 打开新窗口
        //         let newWindow = window.open(routeHref, windowName);
        //         if (newWindow) {
        //             newWindow.name = windowName;
        //             newWindow.focus();
        //         }
        //     } else {
        //         // 当前窗口就是目标窗口，说明没有其他窗口
        //         // 这里有两种选择：
        //         // 1. 在当前窗口跳转（不打开新窗口）
        //         // 2. 强制打开新窗口并关闭当前窗口

        //         // 方案A：在当前窗口跳转（推荐）
        //         window.location.href = routeHref;

        //         // 方案B：强制打开新窗口并关闭当前窗口（需要用户交互）
        //         // const newWindow = window.open(routeHref, windowName + '_new');
        //         // window.close();
        //     }
        // } else {
        //     // 没有存在的窗口或窗口已关闭，打开新窗口
        //     const newWindow = window.open(routeHref, windowName);
        //     if (newWindow) {
        //         newWindow.name = windowName;
        //         newWindow.focus();
        //     }
        // }
    },

    // 关闭AnswerSheet窗口（用于B按钮需要路由跳转时）
    close: () => {
        // let win = window.open('', '_blank')
        // if (win && !win.closed) {
        //     win.close()
        // }
        const win = windowsMap.get('AnswerSheet')
        if (win && !win.closed) {
            win.close()
            windowsMap.delete('AnswerSheet')
        }
    },
    //分片缓存
    setLargeItem: (key, value, chunkSize = 500 * 1024) => {
        // 每片 500KB
        const str = JSON.stringify(value)
        const chunks = Math.ceil(str.length / chunkSize)

        for (let i = 0; i < chunks; i++) {
            const chunk = str.slice(i * chunkSize, (i + 1) * chunkSize)
            localStorage.setItem(`${key}_chunk_${i}`, chunk)
        }
        localStorage.setItem(`${key}_chunks`, chunks)
    },
    //获取缓存
    getLargeItem: (key) => {
        const chunks = localStorage.getItem(`${key}_chunks`)
        if (!chunks) return null

        let result = ''
        for (let i = 0; i < parseInt(chunks); i++) {
            result += localStorage.getItem(`${key}_chunk_${i}`)
        }
        return JSON.parse(result)
    },
    //清除缓存
    removeLargeItem: (key) => {
        // 1. 获取分片数量
        const chunks = localStorage.getItem(`${key}_chunks`)
        if (!chunks) return false

        // 2. 删除所有数据分片
        for (let i = 0; i < parseInt(chunks); i++) {
            localStorage.removeItem(`${key}_chunk_${i}`)
        }

        // 3. 删除元数据（分片数量记录）
        localStorage.removeItem(`${key}_chunks`)
    },

}
export default answerSheetWindowManager